export const easeInOutQuad = (elapsedTime: number): number => {
  if (elapsedTime < 0.5) return 2 * elapsedTime * elapsedTime

  return 1 - (-2 * elapsedTime + 2) ** 2 / 2
}

export const easeInOutQuadWithGap = (elapsedTime: number): number => {
  const isSkipped = Math.round(Math.random() * 10) < 4

  if (isSkipped) return 0
  if (elapsedTime < 0.5) return 2 * elapsedTime * elapsedTime

  return 1 - (-2 * elapsedTime + 2) ** 2 / 2
}
